<template lang="html">
  <v-flex pa-0>
    <v-window :value="window">
      <v-window-item>
        <si-container>
          <v-flex xs12>
            <v-card>
              <v-card-title primary-title>
                Email
                <v-spacer />
              </v-card-title>
              <v-container
                fluid
                pa-4
                pb-0
              >
                <v-layout wrap>
                  <v-flex xs12>
                    <div class="subtitle-2">
                      Enable Sending
                    </div>
                    <div class="caption grey--text darken-2">
                      Enables or disabled all email sending from the system
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <v-switch
                      v-model="enabled.email"
                      :label="`Enable email sending (${enabled.email ? 'ON' : 'OFF'})`"
                      @change="toggleEnabled"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <div class="subtitle-2">
                      Templates
                    </div>
                    <div class="caption grey--text darken-2">
                      References for MailJet templates
                    </div>
                  </v-flex>
                  <v-flex
                    xs12
                    px-0
                  >
                    <v-btn
                      text
                      color="primary"
                      @click="variableMenu = true"
                    >
                      <v-icon left>
                        insert_drive_file
                      </v-icon>New Template
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 />
                </v-layout>
              </v-container>
              <v-list>
                <template v-for="(template, i) in _sortObject(templates)">
                  <v-list-item
                    :key="template.id"
                    :to="`${templatesRoute}/${template.id}`"
                  >
                    <v-list-item-icon>
                      <v-icon>insert_drive_file</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ template.id }}</v-list-item-title>
                      <v-list-item-subtitle>{{ template.description }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider
                    v-if="i + 1 < _sortObject(templates).length"
                    :key="`divider_${template.id}`"
                  />
                </template>
              </v-list>
            </v-card>
          </v-flex>
        </si-container>
      </v-window-item>
      <v-window-item>
        <MessagingTemplateEditor
          :value="activeTemplate"
          :back="templatesRoute"
        />
      </v-window-item>
    </v-window>




    <!-- <v-tabs-items :value="$route.path" class="transparent">
      <v-tab-item v-for="(template, id) in templates" :key="id" :id="`${templatesRoute}/${template.id}`" class="fill-height">
        <AdminTemplatesEditor :value="template"/>
      </v-tab-item>
    </v-tabs-items> -->

    <v-dialog
      v-model="variableMenu"
      max-width="600"
    >
      <v-card>
        <v-card-text>
          <SiVariableEditor
            ref="template_var_input"
            active
            variable-term="template_name"
            :existing-variables="templates"
            @variable="newTemplate"
            @cancel="variableMenu = false"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'
import MessagingTemplateEditor from './components/MessagingTemplateEditor'
export default {
  components: {
    MessagingTemplateEditor
  },
  mixins: [ helpers, binder ],
  data () {
    return {
      tab: null,
      enabled: {},
      templates: {},
      variableMenu: false
    }
  },
  computed: {
    templatesRoute () {
      return '/admin/config/messaging'
    },
    window () {
      return this.$route.params.id ? 1 : 0
    },
    activeTemplate () {
      return this.templates[this.$route.params.id] || {}
    }
  },
  watch: {
    variableMenu (v) {
      requestAnimationFrame(() => {
        if (v) this.$refs.template_var_input.focus()
      })
    }
  },
  beforeMount () {
    this.$store.commit('set_appBarTitle', {title: 'Messaging', icon: 'email'})
    this.$bindRtdb('templates', 'templates', { loader: true })
    this.$bindRtdb('enabled', 'messaging/_enabled', { loader: true })
    // this.$bindxxx(rtdb.ref('templates/'), 'templates', true)
    // this.$bindxxx(rtdb.ref('messaging/_enabled'), 'enabled', true)
  },
  methods: {
    callNewTemplate () {
      this.variableMenu = true
    },
    newTemplate (templateId) {
      rtdb.ref(`templates/${templateId}`).set({ id: templateId })
      requestAnimationFrame(() => {
        this.$router.replace(`${this.templatesRoute}/${templateId}`)
      })
    },
    toggleEnabled () {
      rtdb.ref('messaging/_enabled').set(this.enabled)
    }
  }
}
</script>

<style lang="css" scoped>

</style>
